<template>
  <div v-if="tableData" class="a4">
    <!-- ④-2 의무이행사항 점검결과(공중이용시설_직접관리 시설) -->
    <h3 style="background-color: #2B2D63; padding: 10px 16px; margin-bottom: 26px">④-2 의무이행사항 점검결과(공중이용시설_직접관리 시설)</h3>

    <table style="border-collapse: collapse; width: 100%; border-top: 1px solid #757575; border-left: 1px solid #757575;">
      <colgroup>
        <col width="606px"/>
        <col width="80px"/>
        <col width="80px"/>
        <col width="80px"/>
        <col width="180px"/>
      </colgroup>

      <thead>
        <tr>
          <th style="background-color: #E1E1E1; height: 68px; line-height: 1; font-size: 24px; font-weight: bold; text-align: center; border-right: 1px solid #757575; border-bottom: 1px solid #757575;">중대재해처벌법 의무이행 사항</th>
          <th style="background-color: #E1E1E1; height: 68px; line-height: 1; font-size: 24px; font-weight: bold; text-align: center; border-right: 1px solid #757575; border-bottom: 1px solid #757575;">양호</th>
          <th style="background-color: #E1E1E1; height: 68px; line-height: 1; font-size: 24px; font-weight: bold; text-align: center; border-right: 1px solid #757575; border-bottom: 1px solid #757575;">미흡</th>
          <th style="background-color: #E1E1E1; height: 68px; line-height: 1; font-size: 24px; font-weight: bold; text-align: center; border-right: 1px solid #757575; border-bottom: 1px solid #757575;">해당<br>없음</th>
          <th style="background-color: #E1E1E1; height: 68px; line-height: 1; font-size: 24px; font-weight: bold; text-align: center; border-right: 1px solid #757575; border-bottom: 1px solid #757575;">비고(보완계획)</th>
        </tr>
      </thead>

      <tbody v-for="(data, index) in tableData.list" :key="index" :style="{ pageBreakBefore: data.title === '7. 안전점검 개선사항 조치 여부' && tableData.list[index].title !== tableData.list[index - 1].title? 'always' : 'auto' }">
        <tr v-if="data.title && (index === 0 || tableData.list[index].title !== tableData.list[index - 1].title)">
          <td colspan="5" style="padding: 10px 15px; line-height: 1.2; font-weight: 500; font-size:20px; background-color: #F4F4F4; border-right: 1px solid #757575; border-bottom: 1px solid #757575;" v-html="data.title"></td>
        </tr>
        <tr v-if="!data.title">
          <td style="background-color: #F4F4F4; border-right: 1px solid #757575; border-bottom: 1px solid #757575;"><div style="padding: 10px 15px; font-size:20px; font-weight: 400;" v-html="data.content"></div></td>
          <td style="background-color: #F4F4F4; border-right: 1px solid #757575; border-bottom: 1px solid #757575;"><div style="display: flex; justify-content: center; align-items: center;"><print-checkbox style="scale: 1.3" :value="data.isChecked === '양호'"/></div></td>
          <td style="background-color: #F4F4F4; border-right: 1px solid #757575; border-bottom: 1px solid #757575;"><div style="display: flex; justify-content: center; align-items: center;"><print-checkbox style="scale: 1.3" :value="data.isChecked === '미흡'"/></div></td>
          <td style="background-color: #F4F4F4; border-right: 1px solid #757575; border-bottom: 1px solid #757575;"><div style="display: flex; justify-content: center; align-items: center;"><print-checkbox style="scale: 1.3" :value="data.isChecked === '해당없음'"/></div></td>
          <td style="background-color: #F4F4F4; border-right: 1px solid #757575; border-bottom: 1px solid #757575;"><div v-html="data.note"></div></td>
        </tr>
        <tr v-else>
          <td style="line-height: 1.2; border-right: 1px solid #757575; border-bottom: 1px solid #757575;"><div style="padding: 10px 15px; font-size:18px; font-weight: 400;" v-html="data.content"></div></td>
          <td style="line-height: 1.2; border-right: 1px solid #757575; border-bottom: 1px solid #757575;"><div style="display: flex; justify-content: center; align-items: center;"><print-checkbox style="scale: 1.3" :value="data.isChecked === '양호'"/></div></td>
          <td style="line-height: 1.2; border-right: 1px solid #757575; border-bottom: 1px solid #757575;"><div style="display: flex; justify-content: center; align-items: center;"><print-checkbox style="scale: 1.3" :value="data.isChecked === '미흡'"/></div></td>
          <td style="line-height: 1.2; border-right: 1px solid #757575; border-bottom: 1px solid #757575;"><div style="display: flex; justify-content: center; align-items: center;"><print-checkbox style="scale: 1.3" :value="data.isChecked === '해당없음'"/></div></td>
          <td style="line-height: 1.2; border-right: 1px solid #757575; border-bottom: 1px solid #757575;"><div v-html="data.note"></div></td>
        </tr>
      </tbody>

    </table>
    <div v-if="tableData.footer" style="margin-top: 14px; font-size: 24px;" v-html="tableData.footer"></div>
  </div>
  <div v-else></div>
</template>
<script>
import PrintRadio from "@/components/print/PrintRadio.vue";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";

export default {
  components: {PrintCheckbox, PrintRadio},
  props: {
    header: Object,
    board: Object,
    value: Object,
  },
  computed: {
    tableData () {
      try {
        return this.value.inspectList.find((item) => item.title === '의무이행사항 점검결과(공중이용시설 직접관리 시설)');
      } catch (e) {
        console.error('Error in tableData computed property:', e);
        return {};
      }
    }
  },
  methods: {
  }
}
</script>
